import pathToRegexp, { PathFunctionOptions } from 'path-to-regexp';
import queryString, { StringifyOptions } from 'query-string';

interface InputParams {
  [key: string]: unknown;
}

interface ExpandUrlParams {
  /** The path to expand. Can be parameterized with `/:param`. */
  path: string;
  /** The parameters to expand in the path. */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  params?: Record<string, any>;
  /** Options for url expansion. Rarely used. */
  urlOptions?: PathFunctionOptions;
  /** Query parameters for the url. */
  query?: InputParams;
  /** Options for expanding the query parameters. Rarely used. */
  queryStringOptions?: StringifyOptions;
}

/**
 * Takes in a url template, parameters, and a query, and turns it into an href. This handles urls
 * with `path-to-regexp` and query parameters with `query-string`.
 *
 * @example
 * expandUrl({
 *   path: '/my-product-name/item/:id',
 *   params: { id: 1 },
 *   query: { q: 'test' },
 * });
 * // > "/my-product-name/item/1?q=test"
 *
 * @see https://github.com/pillarjs/path-to-regexp
 * @see https://github.com/sindresorhus/query-string
 */
export const expandUrl = ({
  path,
  params = {},
  urlOptions = {},
  query = {},
  queryStringOptions = {},
}: ExpandUrlParams) => {
  const q = queryString.stringify(query, queryStringOptions);
  return `${pathToRegexp.compile(path)(params, urlOptions)}${q ? `?${q}` : ''}`;
};
